import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    }, 3000);
  };

  return (
    <>
      <style>{`
        .contact-page-wrapper {
          background: #ffffff;
          min-height: 100vh;
        }

        .contact-hero-section {
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          padding: 80px 20px;
          text-align: center;
          color: white;
        }

        .contact-hero-section h1 {
          font-size: 2.8rem;
          font-weight: 700;
          margin-bottom: 15px;
          letter-spacing: -0.5px;
        }

        .contact-hero-section p {
          font-size: 1.15rem;
          opacity: 0.95;
          max-width: 600px;
          margin: 0 auto;
        }

        .contact-main-content {
          max-width: 1200px;
          margin: -50px auto 0;
          padding: 0 20px 80px;
          position: relative;
          z-index: 1;
        }

        .contact-content-grid {
          display: grid;
          grid-template-columns: 380px 1fr;
          gap: 30px;
          align-items: start;
        }

        .contact-info-card {
          background: white;
          border-radius: 10px;
          box-shadow: 0 5px 25px rgba(0,0,0,0.1);
          padding: 35px;
        }

        .contact-info-card h3 {
          font-size: 1.5rem;
          color: #1e3c72;
          margin-bottom: 25px;
          font-weight: 600;
        }

        .contact-info-items {
          display: flex;
          flex-direction: column;
          gap: 25px;
        }

        .contact-info-single {
          display: flex;
          gap: 15px;
          padding: 15px;
          border-radius: 8px;
          transition: background 0.3s;
        }

        .contact-info-single:hover {
          background: #f8f9fa;
        }

        .contact-icon-box {
          width: 45px;
          height: 45px;
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .contact-icon-box svg {
          width: 22px;
          height: 22px;
          stroke: white;
          fill: none;
          stroke-width: 2;
        }

        .contact-info-text h4 {
          font-size: 1rem;
          color: #1e3c72;
          margin-bottom: 5px;
          font-weight: 600;
        }

        .contact-info-text p {
          color: #666;
          line-height: 1.6;
          margin: 0;
          font-size: 0.95rem;
        }

        .contact-form-card {
          background: white;
          border-radius: 10px;
          box-shadow: 0 5px 25px rgba(0,0,0,0.1);
          padding: 40px;
        }

        .contact-form-card h3 {
          font-size: 1.5rem;
          color: #1e3c72;
          margin-bottom: 10px;
          font-weight: 600;
        }

        .contact-form-card .form-subtitle {
          color: #666;
          margin-bottom: 30px;
          font-size: 0.95rem;
        }

        .success-message {
          background: #d4edda;
          border-left: 4px solid #28a745;
          color: #155724;
          padding: 15px 20px;
          border-radius: 6px;
          margin-bottom: 25px;
          font-size: 0.95rem;
        }

        .contact-form-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }

        .form-field {
          display: flex;
          flex-direction: column;
        }

        .form-field.full-width {
          grid-column: 1 / -1;
        }

        .form-field label {
          font-weight: 500;
          color: #333;
          margin-bottom: 8px;
          font-size: 0.9rem;
        }

        .form-field input,
        .form-field textarea {
          padding: 12px 16px;
          border: 1.5px solid #e0e0e0;
          border-radius: 6px;
          font-size: 0.95rem;
          font-family: inherit;
          transition: all 0.3s;
          background: #fafafa;
        }

        .form-field input:focus,
        .form-field textarea:focus {
          outline: none;
          border-color: #2a5298;
          background: white;
          box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.1);
        }

        .form-field textarea {
          resize: vertical;
          min-height: 130px;
        }

        .submit-btn {
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          color: white;
          border: none;
          padding: 14px 40px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s;
          margin-top: 10px;
          width: 100%;
        }

        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(30, 60, 114, 0.3);
        }

        .submit-btn:active {
          transform: translateY(0);
        }

        @media (max-width: 968px) {
          .contact-content-grid {
            grid-template-columns: 1fr;
          }

          .contact-hero-section h1 {
            font-size: 2.2rem;
          }

          .contact-form-grid {
            grid-template-columns: 1fr;
          }

          .contact-main-content {
            margin-top: -30px;
          }
        }

        @media (max-width: 480px) {
          .contact-hero-section {
            padding: 60px 20px;
          }

          .contact-hero-section h1 {
            font-size: 1.9rem;
          }

          .contact-info-card,
          .contact-form-card {
            padding: 25px;
          }
        }
      `}</style>

      <div className="contact-page-wrapper">
        <div className="contact-hero-section">
          <h1>Contact Us</h1>
          <p>Have questions? We're here to help and answer any question you might have.</p>
        </div>

        <div className="contact-main-content">
          <div className="contact-content-grid">
            <div className="contact-info-card">
              <h3>Get in Touch</h3>
              <div className="contact-info-items">
                <div className="contact-info-single">
                  <div className="contact-icon-box">
                    <svg viewBox="0 0 24 24">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                      <circle cx="12" cy="10" r="3"/>
                    </svg>
                  </div>
                  <div className="contact-info-text">
                    <h4>Address</h4>
                    <p>Faisalabad, Punjab<br/>Pakistan</p>
                  </div>
                </div>

                <div className="contact-info-single">
                  <div className="contact-icon-box">
                    <svg viewBox="0 0 24 24">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                    </svg>
                  </div>
                  <div className="contact-info-text">
                    <h4>Phone</h4>
                    <p>+92 321 7600273</p>
                  </div>
                </div>

                <div className="contact-info-single">
                  <div className="contact-icon-box">
                    <svg viewBox="0 0 24 24">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </div>
                  <div className="contact-info-text">
                    <h4>Email</h4>
                    <p>info@loomelectronicparts.com</p>
                  </div>
                </div>

                <div className="contact-info-single">
                  <div className="contact-icon-box">
                    <svg viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10"/>
                      <polyline points="12 6 12 12 16 14"/>
                    </svg>
                  </div>
                  <div className="contact-info-text">
                    <h4>Working Hours</h4>
                    <p>Mon - Sat: 9:00 AM - 8:00 PM<br/>Sunday: 10:00 AM - 6:00 PM</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form-card">
              <h3>Send Message</h3>
              <p className="form-subtitle">Fill out the form below and we'll get back to you as soon as possible.</p>

              {submitted && (
                <div className="success-message">
                  ✓ Thank you! Your message has been sent successfully. We'll contact you soon.
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="contact-form-grid">
                  <div className="form-field">
                    <label>Full Name *</label>
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      placeholder="John Doe"
                    />
                  </div>

                  <div className="form-field">
                    <label>Email Address *</label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      placeholder="john@example.com"
                    />
                  </div>

                  <div className="form-field">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      placeholder="+92 300 1234567"
                    />
                  </div>

                  <div className="form-field">
                    <label>Subject *</label>
                    <input
                      type="text"
                      value={formData.subject}
                      onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                      required
                      placeholder="How can we help?"
                    />
                  </div>

                  <div className="form-field full-width">
                    <label>Your Message *</label>
                    <textarea
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      required
                      placeholder="Write your message here..."
                    />
                  </div>
                </div>

                <button type="submit" className="submit-btn">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;